var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPedidosHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 0H3.75C1.6825 0 0 1.6825 0 3.75V16.25C0 18.3175 1.6825 20 3.75 20H16.25C18.3175 20 20 18.3175 20 16.25V3.75C20 1.6825 18.3175 0 16.25 0ZM19.1667 3.75V4.16667H12.5V0.833333H16.25C17.8583 0.833333 19.1667 2.14167 19.1667 3.75ZM8.33333 0.833333H11.6667V6.25C11.6667 6.93917 11.1058 7.5 10.4167 7.5H9.58333C8.89417 7.5 8.33333 6.93917 8.33333 6.25V0.833333ZM3.75 0.833333H7.5V4.16667H0.833333V3.75C0.833333 2.14167 2.14167 0.833333 3.75 0.833333ZM16.25 19.1667H3.75C2.14167 19.1667 0.833333 17.8583 0.833333 16.25V5H7.5V6.25C7.5 7.39917 8.43417 8.33333 9.58333 8.33333H10.4167C11.5658 8.33333 12.5 7.39917 12.5 6.25V5H19.1667V16.25C19.1667 17.8583 17.8583 19.1667 16.25 19.1667ZM16.6667 16.25C16.6667 16.48 16.48 16.6667 16.25 16.6667H12.9167C12.6867 16.6667 12.5 16.48 12.5 16.25C12.5 16.02 12.6867 15.8333 12.9167 15.8333H16.25C16.48 15.8333 16.6667 16.02 16.6667 16.25Z",
    fill: "#FF9533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedidosHover);
export default __webpack_public_path__ + "static/media/pedidosHover.422c695d42f31d13dd8393bd30e2cc8e.svg";
export { ForwardRef as ReactComponent };